module.exports = __webpack_public_path__ + "img/splash.e59b4029.svg";